import { Navigate, Outlet, useLocation } from 'react-router'
import { PATHS } from '@/app/router/routes'
import type { TypeAccount } from '@/features/users/models/user'
import useAuth from '../hooks/use-auth'

const RequireAuth = ({
  allowedAccounts = []
}: {
  permission?: string
  actions?: string[]
  allowedAccounts?: TypeAccount[]
}) => {
  const isBoneyardBuild = typeof window !== 'undefined' && window.__BONEYARD_BUILD === true
  const { auth } = useAuth()

  const location = useLocation()

  if (isBoneyardBuild) return <Outlet />
  if (!auth) return <Navigate to={PATHS.auth.login} state={{ from: location }} replace />
  if (auth?.typeAccount && allowedAccounts.includes(auth?.typeAccount)) return <Outlet />
  return <Navigate to={PATHS.auth.login} state={{ from: location }} replace />
}

export default RequireAuth
